import React, { useState } from 'react';

import { EikaModal } from '../../../../components/EikaModal';
import useTranslation from '../../../../hooks/useTranslation';
import EditAccountListBody from './EditAccountListBody';

interface Props {
    show: boolean;
    setShow: React.Dispatch<boolean>;
}

const EditAccountList: React.FC<Props> = ({ show, setShow }) => {
    const translated = useTranslation();
    const [isCompleted, setCompleted] = useState(false);

    const onModalClose = () => {
        setCompleted(false);
    };

    return (
        <EikaModal
            id="edit-account-list"
            open={show}
            setOpen={setShow}
            onClose={onModalClose}
            ariaLabel={translated.editAccounts.view}
            timeOut={isCompleted ? 2500 : undefined}
        >
            <EditAccountListBody onCompleted={() => setCompleted(true)} />
        </EikaModal>
    );
};

export default EditAccountList;
